import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'

export const ManualInputTextStyled = styled.div({
  color: colors.neutral[600],
  margin: '0.8rem 0',
  fontFamily: font.family.primary,
  fontWeight: font.weight.regular,
  ...font.size.md,

  '> [role="button"]': {
    color: colors.studio[500],
    cursor: 'pointer',

    '&[aria-disabled="true"]': {
      color: colors.neutral[400],
      cursor: 'default',
    },
  },
})

export const ManualEntryLabel = styled.h4({
  textAlign: 'left',
  backgroundColor: colors.transparent,
  color: colors.black,
  margin: `0 0 ${spacing.smx2}`,
  fontWeight: font.weight.medium,
  ...font.size.lg,
})
